import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { WifiOff, RefreshCw } from 'lucide-react';
import { useConnectionStatus } from '@/hooks/useConnectionStatus';

const ConnectionStatus = () => {
  const { t } = useTranslation();
  const { isOnline, isChecking, checkConnection } = useConnectionStatus();

  if (isOnline) {
    return null; // Не показываем ничего, если подключение есть
  }

  return (
    <Alert className="mb-4 border-red-200 bg-red-50">
      <WifiOff className="h-4 w-4 text-red-600" />
      <AlertTitle className="text-red-800">
        {t('connection.server_unavailable')}
      </AlertTitle>
      <AlertDescription className="text-red-700">
        {t('connection.server_unavailable_description')}
      </AlertDescription>
      <div className="mt-3 flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={checkConnection}
          disabled={isChecking}
          className="border-red-300 text-red-700 hover:bg-red-100"
        >
          {isChecking ? (
            <RefreshCw className="h-4 w-4 animate-spin mr-2" />
          ) : (
            <RefreshCw className="h-4 w-4 mr-2" />
          )}
          {t('connection.retry_connection')}
        </Button>
        <span className="text-xs text-red-600">
          {t('connection.offline_mode')}
        </span>
      </div>
    </Alert>
  );
};

export default ConnectionStatus;
